import ExcelJS from "exceljs";
import { useMonthWiseAttendanceStore } from "../../Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceStore";
import { formatDateTimeWithoutSec, formattedDate, getCurrentDateTime1 } from "../../../../Common/helper/helpar";
import TippingFeeCalculationStore from "./store/TippingFeeCalculationStore";
import jsPDF from "jspdf"; // Add this for PDF export
import autoTable from "jspdf-autotable";
export const  InnerTippingFeeExport = ({ fromDate, toDate }) => {
  const { loading, fetchTippingFeeCalculationInnerZoneReport, tippingFeeInnerZoneReportData, tippingFeeReportData } = TippingFeeCalculationStore()
  const formatTwo = (val) => Number(val || 0).toFixed(2);

  const totalGHMCTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Trips) || 0), 0);
  const totalHMSWTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Trips) || 0), 0);
  const totalTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.total_Trips) || 0), 0);
  const totalGHMCTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_NetWeight) || 0), 0);
  const totalHMSWTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_NetWeight) || 0), 0);
  const totalTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.total_Tonnage) || 0), 0);
  const currentDateTime = getCurrentDateTime1();


  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone Wise Tipping Fee Report");

    // Define styles
    const boldFont = { bold: true };
    const headerText = `Zone-Wise Tipping Fee Report as on (${fromDate})`;
    const downloadDateTime = `Zone-Wise Tipping Fee Report Generated on: ${currentDateTime}`;

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add report title
    worksheet.addRow(["", "", headerText, ""]);
    worksheet.mergeCells(2, 2, 2, 8);
    worksheet.getCell(2, 2).value = headerText;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Define table headers
    const tableHeaderRow = worksheet.addRow([
      "S.No", "Corporation","Zone", "GHMC Trips",  "HMSW Trips", "Total Trips", "GHMC Tonnage", "HMSW Tonnage", "Total Tonnage"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "center", wrapText: true, vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
        bgColor: { argb: "FFFFFFFF" },
      };
    });

    // Add data rows
    tippingFeeInnerZoneReportData.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.CorporationName,
        item.zoneName,
        item.ghmC_Trips,
        // '',
        item.himsW_Trips,
        item.total_Trips,
        item.ghmC_NetWeight,
        // '',
        item.himsW_NetWeight,
        item.total_Tonnage,
      ]).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { horizontal: "center" };
      });
    });

    // Add total row
    worksheet.addRow([
      "",
      "",
      "Total",
      totalGHMCTrips,
      // '',
      totalHMSWTrips,
      totalTrips,
      totalGHMCTonnage,
      // '',
      totalHMSWTonnage,
      totalTonnage,
    ]).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "center" };
    });

    // Set column widths dynamically
    worksheet.columns = [
      { width: 10 },
      { width: 25 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
    ];

    // Save the workbook to a file
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "ZoneWiseTippingFeeReport.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  const downloadAsPDF = () => {
    const doc = new jsPDF();
    const tableColumn = ["S.No","Corporation","Zone", "GHMC Trips", "HMSW Trips", "Total Trips", "GHMC Tonnage",  "HMSW Tonnage", "Total Tonnage"];
    const tableRows = [];
    const headerText = `Zone-Wise Tipping Fee Report as on (${fromDate})`;
    const topHeaderText = `Zone-Wise Tipping Fee Report is generated on (${currentDateTime})`;
    const styledText = (text, x, y, size, options = {}) => {
        const originalSize = doc.getFontSize();
        doc.setFontSize(size);
        doc.text(text, x, y, options);
        doc.setFontSize(originalSize); // Reverts back automatically
    };
     tippingFeeInnerZoneReportData.forEach((item, index) => {
      tableRows.push([
        index + 1,
        item.CorporationName,
        item.zoneName,
        item.ghmC_Trips,
        item.himsW_Trips,
        item.total_Trips,
        formatTwo(item.ghmC_NetWeight),
        formatTwo(item.himsW_NetWeight),
        formatTwo(item.total_Tonnage)
      ]);
    });

    // Add total row
    tableRows.push([
      "",
      "",
      "Total",
      totalGHMCTrips,
      // '',
      totalHMSWTrips,
      totalTrips,
      formatTwo(totalGHMCTonnage),
      formatTwo(totalHMSWTonnage),
      formatTwo(totalTonnage)
    ]);
    const pageWidth = doc.internal.pageSize.width;
    const titleX = pageWidth / 2;
    const dateX = pageWidth / 2;
    // doc.text(downloadDateTime, dateX, 15, { align: "center" });
    styledText(topHeaderText, titleX, 15, 12, { align: "center" });
    styledText(headerText, titleX, 24, 14, { align: "center" });

    // Use autoTable with centered text
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      theme: "striped",
      headStyles: { halign: "center" }, // Center header text
      styles: { halign: "center" }, // Center all table content
    });

    // Save the PDF
    doc.save("ZoneWiseTippingFeeReport.pdf");
  };

  return (
    <div className="d-flex justify-content-end mt-3">
      <button className="btn btn-excel" onClick={downloadAsPDF}>
        <i class="fa-solid fa-file-excel me-1 icon-container"></i> PDF
      </button>
      <button className="btn btn-excel" onClick={downloadAsExcel}>
        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
      </button>
    </div>
  );
};
